// Kawaii cartoon sea turtle - waddling motion (flippers + body bob).
export default function CartoonTurtle({ className = "w-32 h-28" }) {
  return (
    <svg viewBox="0 0 260 200" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <defs>
        <radialGradient id="shellG" cx="40%" cy="35%" r="70%">
          <stop offset="0%" stopColor="#A7D9A0" />
          <stop offset="60%" stopColor="#5BB654" />
          <stop offset="100%" stopColor="#2E6B2B" />
        </radialGradient>
        <radialGradient id="bodyG" cx="50%" cy="50%" r="65%">
          <stop offset="0%" stopColor="#E6F4D1" />
          <stop offset="100%" stopColor="#B4DA80" />
        </radialGradient>
        <radialGradient id="turtleEye" cx="35%" cy="35%" r="65%">
          <stop offset="0%" stopColor="#7DD3FC" />
          <stop offset="60%" stopColor="#3B82F6" />
          <stop offset="100%" stopColor="#0A3F8F" />
        </radialGradient>
      </defs>
      <style>{`
        .t-flip-f { animation: tflipF 0.55s ease-in-out infinite; transform-origin: 175px 130px; }
        .t-flip-b { animation: tflipB 0.55s ease-in-out infinite; transform-origin: 90px 145px; }
        .t-flip-bk { animation: tflipB 0.55s ease-in-out infinite; transform-origin: 70px 130px; }
        .t-eye { animation: tblink 4s ease-in-out infinite; transform-origin: center; transform-box: fill-box; }
        .t-body { animation: tBob 0.55s ease-in-out infinite; transform-origin: 130px 110px; }
        .t-tail { animation: tTail 0.6s ease-in-out infinite; transform-origin: 50px 120px; }
        @keyframes tflipF { 0%,100% { transform: rotate(0deg); } 50% { transform: rotate(-15deg); } }
        @keyframes tflipB { 0%,100% { transform: rotate(0deg); } 50% { transform: rotate(12deg); } }
        @keyframes tblink { 0%,93%,100% { transform: scaleY(1); } 95%,97% { transform: scaleY(0.1); } }
        @keyframes tBob { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-2px); } }
        @keyframes tTail { 0%,100% { transform: rotate(-10deg); } 50% { transform: rotate(10deg); } }
      `}</style>

      <g className="t-body">
        {/* Tail */}
        <g className="t-tail">
          <path d="M 50 125 Q 35 122 30 115 L 36 130 Q 42 132 50 130 Z" fill="#5BB654" stroke="#2E6B2B" strokeWidth="2" />
        </g>
        {/* Back flipper */}
        <g className="t-flip-bk">
          <ellipse cx="68" cy="138" rx="20" ry="13" fill="#5BB654" stroke="#2E6B2B" strokeWidth="2" transform="rotate(-20 68 138)" />
          <ellipse cx="60" cy="135" rx="10" ry="5" fill="#A7D9A0" opacity="0.7" transform="rotate(-20 60 135)" />
        </g>
        {/* Back leg */}
        <g className="t-flip-b">
          <ellipse cx="100" cy="155" rx="22" ry="14" fill="#5BB654" stroke="#2E6B2B" strokeWidth="2" transform="rotate(20 100 155)" />
          <ellipse cx="95" cy="150" rx="10" ry="5" fill="#A7D9A0" opacity="0.7" transform="rotate(20 95 150)" />
        </g>

        {/* Shell (back) */}
        <path d="M 70 95 Q 130 50 195 95 Q 200 130 165 135 Q 130 140 100 135 Q 65 130 70 95 Z" fill="url(#shellG)" stroke="#1F4A1D" strokeWidth="2.5" />
        {/* Hexagon pattern on shell */}
        {[
          { x: 110, y: 90 }, { x: 130, y: 85 }, { x: 150, y: 90 },
          { x: 100, y: 110 }, { x: 130, y: 108 }, { x: 160, y: 110 },
          { x: 115, y: 125 }, { x: 145, y: 125 },
        ].map((p, i) => (
          <path
            key={i}
            d={`M ${p.x} ${p.y - 8} L ${p.x + 8} ${p.y - 4} L ${p.x + 8} ${p.y + 4} L ${p.x} ${p.y + 8} L ${p.x - 8} ${p.y + 4} L ${p.x - 8} ${p.y - 4} Z`}
            fill="#A7D9A0"
            opacity="0.65"
            stroke="#2E6B2B"
            strokeWidth="1"
          />
        ))}
        {/* Shell highlight */}
        <ellipse cx="115" cy="75" rx="25" ry="8" fill="#D0EAB0" opacity="0.7" />

        {/* Front flipper */}
        <g className="t-flip-f">
          <ellipse cx="180" cy="138" rx="22" ry="14" fill="#7BC274" stroke="#2E6B2B" strokeWidth="2" transform="rotate(15 180 138)" />
          <ellipse cx="185" cy="133" rx="10" ry="5" fill="#A7D9A0" opacity="0.7" transform="rotate(15 185 133)" />
        </g>

        {/* HEAD - sticking out to the right */}
        <ellipse cx="210" cy="105" rx="32" ry="28" fill="url(#bodyG)" stroke="#2E6B2B" strokeWidth="2.5" />
        {/* Head texture */}
        <circle cx="218" cy="92" r="2" fill="#7BC274" opacity="0.7" />
        <circle cx="225" cy="105" r="1.5" fill="#7BC274" opacity="0.7" />
        <circle cx="210" cy="88" r="1.5" fill="#7BC274" opacity="0.7" />

        {/* Eyes - HUGE */}
        <ellipse cx="200" cy="98" rx="11" ry="14" fill="#FFFFFF" stroke="#2E6B2B" strokeWidth="2" />
        <ellipse cx="222" cy="98" rx="11" ry="14" fill="#FFFFFF" stroke="#2E6B2B" strokeWidth="2" />
        <g className="t-eye">
          <ellipse cx="201" cy="102" rx="7" ry="9" fill="url(#turtleEye)" />
          <ellipse cx="223" cy="102" rx="7" ry="9" fill="url(#turtleEye)" />
          <ellipse cx="201" cy="105" rx="4" ry="5" fill="#0A1F3F" />
          <ellipse cx="223" cy="105" rx="4" ry="5" fill="#0A1F3F" />
          <ellipse cx="204" cy="99" rx="2.5" ry="3" fill="#FFFFFF" />
          <ellipse cx="226" cy="99" rx="2.5" ry="3" fill="#FFFFFF" />
          <circle cx="198" cy="106" r="1.2" fill="#FFFFFF" opacity="0.9" />
          <circle cx="220" cy="106" r="1.2" fill="#FFFFFF" opacity="0.9" />
        </g>
        {/* Eyebrows happy */}
        <path d="M 190 82 Q 200 76 213 81" stroke="#2E6B2B" strokeWidth="2" fill="none" strokeLinecap="round" />
        <path d="M 213 81 Q 225 76 233 84" stroke="#2E6B2B" strokeWidth="2" fill="none" strokeLinecap="round" />
        {/* nostrils */}
        <circle cx="234" cy="105" r="1.2" fill="#2E6B2B" />
        <circle cx="234" cy="111" r="1.2" fill="#2E6B2B" />
        {/* Smile */}
        <path d="M 218 120 Q 224 128 232 122" stroke="#2E6B2B" strokeWidth="2" fill="none" strokeLinecap="round" />
        {/* Cheeks */}
        <ellipse cx="194" cy="118" rx="6" ry="3.5" fill="#F472B6" opacity="0.5" />
        <ellipse cx="234" cy="118" rx="5" ry="3" fill="#F472B6" opacity="0.45" />
      </g>
    </svg>
  );
}
